<script>
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import { sendFandomAnalyticsEvent } from "src/modules/fandom_analytics_module.js"
import Flickity from "flickity";
import { get, map, pick, filter, flatten, merge, negate } from "lodash";
import { disableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";

/*
 * For the ajax call we need to transform our data about the filters from
 * { a: true, b: false, c: true, d: false } & { foo: { filters: [a, b, c] }, bar: { filter: [d] } }
 * to
 * [[a, c]]
*/
const filterMapToArray = (filtersMap, activeFilters) => {
  return filter(
    map(
      filtersMap,
      value => {
        return filter(
          map(
            pick(
              activeFilters,
              map(value.subFilters, filter => filter.name)
            ),
            (value, key) => value ? key : false
          ),
          filter => filter !== false
        );
      }
    ),
    filters => filters.length > 0
  );
};

const isAllergen = (filter) => {
  return filter.includes("allergene");
};

// Return an array of array without allergens (strings that contains the word 'allergene')
const arrayWithoutAllergens = (array) => {
  return array.map(
    filters => filter(
      filters,
      negate(isAllergen)
    )
  );
};

export default {
  mixins: [fandomBasicMixin],
  data() {
    return {
      subfilters: [],
      showSubfilters: false,
      filteringTag: null,
      activeSubFilters: {},
      resultContent: null,
      appliedFilters: [],
      subCategoriesCarousel: null,
      autocompleteSelectedContent: null,
      autocompleteContents: [],
      primaryColor: "",
      secondaryColor: "",
      primaryButtonClass: "",
      secondaryButtonClass: ""
    };
  },
  mounted() {
    this.setColors();
    if (Fandom.exists(this.menuContent) || this.subFilters.length > 0) {
      const buildCarousel = () => {
        if (this.subFilters.length > 0 && !Fandom.exists(this.subCategoriesCarousel)) {
          this.subCategoriesCarousel = new Flickity(this.$refs["sub-categories-icons"], {
            draggable: ">1",
            prevNextButtons: false,
            cellAlign: "left",
            wrapAround: false,
            freeSCroll: false,
            pageDots: false
          });
        }
      };

      const toggleCarousel = () => {
        if (this.isMobile) {
          buildCarousel();
        } else {
          if (Fandom.exists(this.subCategoriesCarousel)) {
            this.subCategoriesCarousel.destroy();
            this.subCategoriesCarousel = null;
          }
        }
      };

      // Block/unlock body scroll with the filters-modal
      $(this.$refs["filters-modal"]).on("show.bs.modal", () => {
        Vue.nextTick(() => {
          disableBodyScroll(this.$refs["filters-modal"]);
        });
      });
      $(this.$refs["filters-modal"]).on("hide.bs.modal", clearAllBodyScrollLocks);

      this.setSearchText("");
      this.buildActiveSubFilters();
      this.loadFiltersFromHistory();

      // Build a carousel if the viewport is mobile, and add an event listener to build it if the viewport becames mobile
      this.getSubCategories(toggleCarousel);
      $(window).on("debouncedResize", toggleCarousel);

      // WARNING: Run as a last command to prevent conflicts with previous requests
      this.applyFilters();
    }
  },
  beforeDestroy() {
    $(window).off("debouncedResize");
  },
  computed: {
    componentStyles() {
      return {
        "--primary-color": this.primaryColor,
        "--secondary-color": this.secondaryColor
      };
    },
    searchPlaceholder() {
      const placeholder = this.ft('recipe.search_placeholder');
      return get(this, ["content", "search_placeholder"], placeholder);
    },
    isMobile() {
      return globalState.viewport.xs;
    },
    subFilters() {
      return get(this, "subfilters", []).map(content => this.getContent(content));
    },
    menuContent() {
      const name = get(this, ["content", "category_filter"], "");
      return Fandom.getContent(name);
    },
    advancedFilters() {
      const advFilters = this.getContent(this.content.advanced_filter);
      if (Fandom.exists(advFilters) && !!advFilters.filters && advFilters.filters.length > 0) {
        return advFilters.filters.map(topFilter => {
          return {
            title: topFilter.title,
            subFilters: topFilter.filters.map(subFilterName => {
              const subFilter = this.getContent(subFilterName);
              return {
                name: subFilter.name,
                title: subFilter.title
              };
            })
          };
        });
      } else {
        return [];
      }
    }
  },
  methods: {
    setColors() {
      const primaryColor = get(this, ["content", "primary_color"], "red-cabbage");
      const secondaryColor = get(this, ["content", "secondary_color"], "purple-basil");
      this.primaryColor = `var(--${primaryColor})`;
      this.secondaryColor = `var(--${secondaryColor})`;
      this.primaryButtonClass = `btn-${primaryColor}`;
      this.secondaryButtonClass = `btn-${secondaryColor}`;
    },
    getSubCategories(successCallback) {
      const matchingParents = filter(this.content.parent_names, parent => this.content.name.includes(parent) );
      const mainContent = matchingParents.length === 1 ? matchingParents[0] : this.content.name;
      const params = {
        layout_extra_field_name: "$empty",
        layout: "system-category-filter",
        include_children: true,
        include_content_children: false,
        content_filtering: ["sotto-portate"],
        max_depth: 1
      };
      Fandom.getContents(mainContent, params, (data) => {
        this.subfilters = data.name_to_content[mainContent].children;
        data.name_to_content[this.content.name] = this.content;
        globalState.pageModel.name_to_content = merge(globalState.pageModel.name_to_content, data.name_to_content);
        Vue.nextTick(successCallback);
      });
    },
    getSearchText() {
      const vaComponent = this.$refs["v-autocomplete-ref"];
      return vaComponent ? Fandom.searchTextToBackendFormat(vaComponent.searchText) : "";
    },
    setSearchText(text) {
      const vaComponent = this.$refs["v-autocomplete-ref"];
      // monkey patch on "key enter" to handle apply filters when no item is selecte on completion list
      vaComponent.keyEnter = (e) => {
        if (vaComponent.showList && vaComponent.internalItems[vaComponent.cursor]) {
          vaComponent.onSelectItem(vaComponent.internalItems[vaComponent.cursor]);
        } else {
          this.applyFilters();
        }
        vaComponent.showList = false;
      };
      // set the autocomplete component initial search text
      vaComponent.searchText = text;
    },
    autocompleteGetLabel(content) {
      return (content && content.title) || "";
    },
    autocompleteItemClicked(content) {
      if (Fandom.exists(content.slug)) {
        window.location.href = Fandom.applyContextToUrl(content.slug);
      }
    },
    autocompleteUpdateContents() {
      this.autocompleteContents = [];

      const successBlock = (data) => {
        const childrens = get(data, ["name_to_content", data.main_content_name, "children"], []);
        this.autocompleteContents = childrens.map(name => data.name_to_content[name]);
      };

      const params = this.filtersToGetContentsParams(false, "system-recipe-search-snippet");
      Fandom.getAutocompleteContents(params, successBlock);
    },
    autocompleteInputChanged() {
      if (this.getSearchText().length < 3) {
        this.autocompleteContents = [];
      }
    },
    searchRecipes() {
      this.getSearchableContents(false);
    },
    isCategoryActive(filter) {
      return this.content.name.includes(filter.name);
    },
    buildActiveSubFilters() {
      const advFilters = this.getContent(this.content.advanced_filter);
      if (Fandom.exists(advFilters) && !!advFilters.filters &&  advFilters.filters.length > 0) {
        advFilters.filters.forEach(advFilter => {
          advFilter.filters.forEach(filter => {
            Vue.set(this.activeSubFilters, filter, false);
          });
        });
      }
    },
    loadFiltersFromHistory() {
      const filters = Fandom.getUrlParameter("filters");
      if (Fandom.exists(filters)) {
        filters.split(",").forEach(filter => {
          if (Fandom.exists(this.activeSubFilters[filter])) {
            this.activeSubFilters[filter] = true;
          }
        });
      }
    },
    unapplyFilter(name) {
      this.activeSubFilters[name] = false;
      this.applyFilters();
    },
    applyFilters() {
      this.appliedFilters = filter(
        map(
          this.activeSubFilters,
          (value, key) => value ? { title: this.getContent(key).title, name: key } : false
        ),
        value => value !== false
      );
      this.getSearchableContents(false);
    },
    resetActiveFilters() {
      let reload = false;
      const filterNames = Object.keys(this.activeSubFilters);
      filterNames.forEach(filter => {
        reload = reload || this.activeSubFilters[filter];
        this.activeSubFilters[filter] = false;
      });
      if (reload && this.appliedFilters.length > 0) {
        this.applyFilters();
      }
    },
    toggleSubFilter(name) {
      Vue.set(this.activeSubFilters, name, !this.activeSubFilters[name]);
    },
    getSearchableContents(appendContents) {
      const successBlock = (data) => {
        // google analytics
        if (this.$refs["v-autocomplete-ref"].searchText && this.$refs["v-autocomplete-ref"].searchText != '' && !appendContents){
          sendFandomAnalyticsEvent("Interaction", "Search", this.$refs["v-autocomplete-ref"].searchText);
        }

        this.resultContent = globalState.pageModel.name_to_content[data.main_content_name];

        // forward disable infinite scrolling params to child fixed grid
        this.resultContent.disable_infinite_scrolling = this.content.disable_infinite_scrolling;
        this.resultContent.url = this.content.url

        $(this.$refs["filters-modal"]).modal("hide");
        Vue.nextTick(() => Fandom.emit("dom-items-loaded"));

        // Updates the applied filters in the url address
        const url = this.updateQueryString(window.location.href, "filters", this.appliedFilters.map(item => item.name).join(","));
        history.replaceState({}, null, url);
      };
      const params = this.filtersToGetContentsParams(appendContents, this.content.tile_layout);
      Fandom.getSearchableContents(successBlock, params, appendContents);
    },
    updateQueryString(uri, key, value) {
      const re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
      const separator = uri.indexOf('?') !== -1 ? "&" : "?";
      let result = "";

      if (uri.match(re)) {
        result = uri.replace(re, '$1' + key + "=" + value + '$2');
      }
      else {
        result =  uri + separator + key + "=" + value;
      }

      return result.replace(/[^=&]+=(&|$)/g,"").replace(/&$/,"");
    },
    alternativeAppendContents() {
      this.getSearchableContents(true);
    },
    filtersToGetContentsParams(appendContents, layout = "tile-recipe") {
      const params = {
        layout: layout,
        layout_extra_field_name: "$empty",
        include_rich_info: true,
        exclude_content_ids: [this.content.id],
        content_filtering: [],
        include_extra_field_content_filtering: true,
        search_text: this.getSearchText(),
        max_depth: 1
      };

      const subFiltersArray = filterMapToArray(this.advancedFilters, this.activeSubFilters);
      const relatedIngredients = get(this, ["content", "related_ingredients"], []);
      const filtersToExclude = filter(flatten(subFiltersArray), isAllergen);
      const filtersToInclude = arrayWithoutAllergens(subFiltersArray);

      if (Fandom.exists(this.resultContent)) {
        params.main_content_name = this.resultContent.name;
      }

      if (Fandom.exists(this.filteringTag)) {
        params.content_filtering.push([this.filteringTag]);
      }

      if (subFiltersArray.length > 0) {
        params.exclude_extra_field_contents_children = filtersToExclude;
        params.content_filtering = params.content_filtering.concat(filtersToInclude);
      }

      if (Fandom.exists(this.content.grid_contents)) {
        params.content_filtering = params.content_filtering.concat(this.content.grid_contents);
      }

      if (Fandom.exists(this.content.limit)) {
        params.limit = parseInt(this.content.limit);
      } else {
        params.limit = 16;
      }

      if(!get(this, ["content", "exclude_self_filtering"], false)) {
        params.content_filtering.push([this.content.name].concat(relatedIngredients));
      }

      if (appendContents) {
        Object.values(globalState.pageModel.name_to_content).forEach( c => {
          params.exclude_content_ids.push(c["id"]);
        });
      }
      return params;
    }
  }
};

</script>

<template>
  <div v-easyadmin="easyadminId" :id="`ref-${easyadminId}`" :class="contentType" class="container-fluid" v-if="isContentVisibleToUser()" :style="componentStyles" filters-component>
    <div class="row bg-primary py-3 justify-content-center align-items-center">
      <div class="col-12" :class="{'col-md-4': advancedFilters.length > 0, 'col-md-6': advancedFilters.length === 0}">
        <v-autocomplete
          ref="v-autocomplete-ref"
          class="form-control search-input p-2 d-flex align-items-center"
          :items="autocompleteContents"
          v-model="autocompleteSelectedContent"
          :get-label="autocompleteGetLabel"
          component-item="stripe-search-autocomplete-item"
          @item-selected="autocompleteItemClicked"
          @update-items="autocompleteUpdateContents"
          @input="autocompleteInputChanged"
          :input-attrs="{ placeholder : searchPlaceholder }"
          :auto-select-one-item="false"
          ></v-autocomplete>
      </div>
      <div class="col-6 col-md-auto mt-3 mt-md-0">
        <button
          class="btn w-100 w-md-auto d-flex align-items-center justify-content-center px-3 px-md-5 py-4"
          :class="secondaryButtonClass"
          @click="searchRecipes"
          >
          <i class="far fa-search mx-2"></i>
          {{ft("globals.search")}}
        </button>
      </div>
      <div class="col-6 col-md-auto mt-3 mt-md-0 pl-0 pl-md-3" v-if="advancedFilters.length > 0">
        <button
          class="btn btn-outline-white w-100 w-md-auto d-flex align-items-center justify-content-center px-3 px-md-5 py-4"
          data-toggle="modal"
          :data-target="`#${content.name}-filters-modal`"
          >
          <i class="far fa-filter mx-2"></i>
          {{ft("globals.filter")}}
        </button>
      </div>
    </div>
    <div class="row justify-content-end mt-4 mt-md-4">
      <icon-menu :content="menuContent"></icon-menu>
      <div class="container px-sm-0">
        <div class="row mx-sm-0">
          <div
            class="col-12 sub-filters-container my-4 py-3 border-top border-bottom"
            :class="{'d-flex align-items-center justify-content-center': !isMobile}"
            ref="sub-categories-icons"
            v-if="subFilters.length > 0"
            >
            <a
              class="mx-3 category-sub-filter"
              v-for="(subFilter, subIndex) in subFilters"
              :class="{'active': isCategoryActive(subFilter)}"
              :href="applyContextToUrl(subFilter.slug)"
              :key="`child-${subIndex}`"
              >
              {{subFilter.title}}
            </a>
          </div>
          <div class="px-sm-0 col-12 d-flex flex-wrap">
            <h1 class="px-3 px-sm-0 mb-3 mx-2 main-content-title">{{content.title}}</h1>
            <button
              class="btn rounded-pill mt-auto mb-3 mx-1 text-capitalize px-2 py-1 d-inline-flex align-items-center"
              :class="primaryButtonClass"
              v-for="(filter, index) in appliedFilters"
              :key="`aapliedfilter-${index}`"
              @click="unapplyFilter(filter.name)"
              >
              <span class="mx-1">{{filter.title}}</span>
              <i class="far fa-times mr-1"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="container px-0">
      <breadcrumb class="px-2 pt-0"></breadcrumb>
    </div>
    <template v-if="resultContent">
      <grid-fixed
        class="pb-3 pb-md-4"
        :ref="`grid-isotope-${this.resultContent.name}`"
        :content="resultContent"
        :column-count="content.column_count"
        :key="resultContent.name"
        :alternative-append-contents="alternativeAppendContents"
        ></grid-fixed>
    </template>
    <div class="row justify-content-center bg-primary text-white py-4" v-if="content.description">
      <div class="col-12 col-md-10 col-lg-7 text-center meta-description py-4" v-html="content.description"></div>
    </div>
    <div class="modal fade align-items-center justify-content-center" ref="filters-modal" :id="`${content.name}-filters-modal`" v-if="advancedFilters.length > 0">
      <div class="modal-dialog filters-modal">
        <div class="modal-content">
          <div class="modal-header border-bottom-0">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body pb-sm-3 pb-md-4">
            <div class="filters-container px-3 px-md-4" v-if="advancedFilters.length > 0">
              <div v-for="(filter, index) in advancedFilters" :key="index">
                <h3 class="filter-section-title text-uppercase">{{filter.title}}</h3>
                <div class="subfilters-container pt-3 pb-4 border-top">
                  <button
                    class="btn rounded-pill m-1 btn-filter text-capitalize px-2 py-1"
                    v-for="(subfilter, subindex) in filter.subFilters"
                    :class="{'active': activeSubFilters[subfilter.name]}"
                    :key="`subfilter-${index}-${subindex}`"
                    @click="toggleSubFilter(subfilter.name)"
                    >
                    {{subfilter.title}}
                  </button>
                </div>
              </div>
            </div>
            <div class="w-100 d-flex justify-content-center py-3">
              <button class="btn px-3 mr-2" :class="secondaryButtonClass" @click="applyFilters">{{ft("globals.apply")}}</button>
              <button class="btn btn-kenwood-dark-grey px-3" @click="resetActiveFilters">{{ft("globals.reset")}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.meta-description {
  font-size: 1.125rem;
  font-family: $bressay-font;

  a {
    font-weight: normal;
    font-style: italic;
    color: $black;
  }
}

.category-sub-filter {
  font-size: .8rem;
  color: $kenwood-dark-grey;

  &.active {
    color: var(--primary-color);
  }

  @include hover {
    color: var(--secondary-color);
  }
}

.btn-filter {
  color: $black;
  border-color: $black;
  font-size: .75rem;

  @include hover {
    color: $white;
    border-color: transparent;
    background-color: var(--primary-color);
  }

  &.active {
    color: $white;
    border-color: transparent;
    background-color: var(--secondary-color);
  }
}

.filter-section-title {
  font-size: .875rem;
  font-family: $font-family-base;

  @include media-breakpoint-up(md) {
    font-size: 1.2875rem;
  }
}

.filters-modal {
  max-width: 95vw;
  background-color: $kenwood-light-grey;

  @include media-breakpoint-up(md) {
    max-width: 75vw;
  }
}
</style>
